import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-batch-print',
  templateUrl: './button-batch-print.component.html',
  styleUrls: ['./button-batch-print.component.scss']
})
export class ButtonBatchPrintComponent implements OnInit {
  constructor() {}

  @Input() isDisabled: boolean;
  @Output() showPrintClick = new EventEmitter<{ menuType: 'article' | 'spellcheck'; event: MouseEvent }>();

  showSpinner = false;

  ngOnInit() {}

  showPrint(menuType: 'article' | 'spellcheck', event: MouseEvent) {
    event.stopPropagation();
    this.showPrintClick.emit({ menuType, event });
  }
}
